import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Input } from '../../../../../../../../CommonComponents/OPL/Input/Input';
import { useAccountFormFieldDisabled } from '../../hooks/useCanEditLinkedAccountOwnerAndSync';

export const AccountDescription = () => {
  const formBag = useFormContext();
  const isOrion = formBag.watch('bankAccount.IsOrion');
  const accountName = formBag.watch('bankAccount.AccountName');
  const isFieldDisabled = useAccountFormFieldDisabled(false, { accountDescriptionField: true });

  const { ref, onBlur, name } = formBag.register('bankAccount.AccountName');

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    formBag.setValue('bankAccount.AccountName', event.target.value, { shouldDirty: true });
  };

  return (
    <Input
      ref={ref}
      name={name}
      onBlur={onBlur}
      value={accountName ?? ''}
      onChange={handleChange}
      label="Account Description"
      maxLength={32}
      disabled={isFieldDisabled || isOrion}
    />
  );
};
